var map = {
	"./amount.svg": "a139",
	"./arrow-down.svg": "c874",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./arrows-vertical.svg": "3c79",
	"./brand-carbon-filter.svg": "d058",
	"./brand-edge-filter.svg": "86cf",
	"./brand-standard-filter.svg": "a244",
	"./check.svg": "7bae",
	"./checkGradient.svg": "7b47",
	"./check_green.svg": "b67e",
	"./empty-ellipse.svg": "3f3c",
	"./envelope.svg": "8e29",
	"./feedbackicon-1.svg": "33bc",
	"./feedbackicon-2.svg": "9278",
	"./feedbackicon-3.svg": "a8d4",
	"./feedbackicon-4.svg": "bfe6",
	"./feedbackicon-5.svg": "141c",
	"./feedbackicon-6.svg": "27cc",
	"./feelsLike.svg": "2630",
	"./follow-products-info.svg": "82df",
	"./green-check.svg": "8315",
	"./humidity.svg": "0c16",
	"./icon_check.svg": "bab1",
	"./info.svg": "76ed",
	"./karbonmonoksit.svg": "73b4",
	"./minus.svg": "3e24",
	"./next-active.svg": "93a9",
	"./next-passive.svg": "6bf4",
	"./nikotin.svg": "d2b0",
	"./plus.svg": "eb38",
	"./point.svg": "7c2f",
	"./prev-active.svg": "9bf0",
	"./prev-passive.svg": "f0cb",
	"./radius.svg": "2422",
	"./rain.svg": "02ad",
	"./right-arrow-icon.svg": "6fbf",
	"./right-direction-arrow.svg": "8891",
	"./rosette-icon.svg": "b0cc",
	"./trash-icon.svg": "428fe",
	"./wind.svg": "079d",
	"./zifir.svg": "1405"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";